var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2514_4895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28833 8.19911C2.08446 9.02711 3.19237 9.5593 4.42081 9.60891C4.72923 9.62137 4.98944 9.38141 5.0019 9.07311C5.01436 8.76469 4.7744 8.50448 4.46624 8.49186C3.5343 8.45391 2.69964 8.05278 2.0936 7.42387C1.48839 6.79428 1.1179 5.94409 1.11761 5.00178C1.1179 4.03536 1.50778 3.16563 2.14071 2.53159C2.77473 1.89852 3.6446 1.50877 4.61087 1.5085C5.57716 1.50879 6.44729 1.89854 7.08106 2.53159C7.71397 3.16563 8.10387 4.03534 8.10415 5.00178C8.10415 5.06981 8.10208 5.13729 8.09825 5.2042L7.43241 4.87555C7.36011 4.83993 7.27612 4.83938 7.21073 4.87387C7.14507 4.90879 7.10626 4.9742 7.10792 5.04762L7.17358 7.97407C7.17581 8.05776 7.22983 8.13729 7.31214 8.17844C7.39499 8.21889 7.49116 8.21377 7.55848 8.16403L9.92147 6.43653C9.98104 6.39315 10.0093 6.32264 9.99686 6.24948C9.98495 6.17606 9.93341 6.10997 9.86081 6.0742L9.16311 5.72989C9.20094 5.49227 9.22206 5.24938 9.22206 5.00178C9.22233 3.73026 8.70497 2.57385 7.87141 1.74116C7.03868 0.90772 5.88257 0.390377 4.61089 0.39063C3.3395 0.390357 2.18311 0.90772 1.3504 1.74114C0.516844 2.57385 -0.000519156 3.73024 -0.000264525 5.00176C-0.000519156 6.24129 0.491082 7.37178 1.28833 8.19911Z",
    fill: "#031D42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_4895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(-1 0 0 -1 9.99976 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.c53dfb5e.svg";
export { ForwardRef as ReactComponent };